import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import heroImage from "../assets/images/heroeg.png";

function Hero() {
  const searchRef = useRef();
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    history.push({
      pathname: "/mentors",
      state: searchRef.current.value,
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      history.push({
        pathname: "/mentors",
        state: searchRef.current.value,
      });
    }
  };

  return (
    <div>
      <div className="container mx-auto flex px-2 py-16 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-7xl lg:text-5xl xl:text-7xl text-3xl mb-4 font-bold text-gray-900">
            Find and Meet Mentors to enhance your Dev journey
          </h1>
          <p className="mb-8 text-lg text-black font-medium">
            Get guidance and learn from mentors in world class companies with
            our global community.
          </p>
          <div className="flex w-full md:justify-start justify-center items-center">
            <div className="relative mr-4 md:w-full lg:w-full xl:w-1/2 w-2/4">
              <input
                type="text"
                id="hero-field"
                name="hero-field"
                ref={searchRef}
                className="w-full bg-gray-100 rounded-xl py-1.5 border-gray-300 focus:ring-2 focus:ring-blue-200 focus:bg-transparent focus:border-blue-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                placeholder="Try 'Brain', 'Rohan' or 'Vrijraj'"
                onKeyPress={handleKeyPress}
              />
            </div>
            <button
              onClick={handleSubmit}
              className="inline-flex text-white font-medium bg-gradient-to-r from-blue-500 to-blue-900 border-0 py-2 px-6 focus:outline-none rounded-lg text-lg"
            >
              Search
            </button>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center"
            src={heroImage}
            alt="hero"
          />
        </div>
      </div>
    </div>
  );
}

export default Hero;
